<template>
  <div class="animated fadeIn">
    <div class="container">
      <div class="row">
        <div class="col-md-12 pt-2 pb-3 pl-4">
          <h3>
            <i class="fas fa-map-marked-alt"></i> Módulo de Visitas
            <small style="font-size: 18px;">| Oportunidades</small>
          </h3>
        </div>
        <div class="col-md-12 text-right">
          <div class="d-flex justify-content-between">
          <b-button
            class="btn btn-sm btn-third rounded-4"
            size="sm"
            @click="showModalNewLead"
          >
            <i class="fas fa-user-plus"></i>
            <span>&nbsp; Nova Oportunidade</span>
          </b-button>
          <button
            type="button"
            class="btn btn-third btn-sm"
            v-b-tooltip.hover
            :title="$lang.Common.Tooltip.ButtonBack"
            @click="onBack"
          >
            <i class="fas fa-undo"></i>
            <span class="d-md-down-none">{{
              $lang.Common.Buttons.Back
            }}</span>
          </button>
        </div>
        </div>
      </div>
      <div class="row pt-4 pb-3">
        <div class="col-12">
          <div>
            <b-tabs class="card__tab__container" card justified>
              <b-tab class="col-md-12" title="ATIVOS" active>
                <div
                  class="col-md-4 d-inline-block"
                  v-for="(card, index) in cards.ativos"
                  :key="card.id"
                >
                  <p>
                    {{ card.boardColumn.board.nome }} --
                    {{ card.boardColumn.nome }}
                  </p>
                  <task-card
                    :task="card"
                    :color="card.boardColumn.cor"
                    :boardColumnId="card.boardColumn.id"
                    :boardPosition="
                      card.boardColumn.position ? card.boardColumn.position : 0
                    "
                    :percentage="card.boardColumn.percentual"
                    :hoursUntilAlert="card.boardColumn.hoursUntilAlert"
                    :index="index"
                    :hasObservation="false"
                    @Open="showLead(card)"
                  ></task-card>
                </div>
              </b-tab>
              <b-tab v-show="cards.ganhos.length === 0" class="col-md-12" title="GANHOS">
                <div
                  class="col-md-4 d-inline-block"
                  v-for="(card, index) in cards.ganhos"
                  :key="card.id"
                >
                  <p>
                    {{ card.boardColumn.board.nome }} --
                    {{ card.boardColumn.nome }}
                  </p>
                  <task-card
                    :task="card"
                    :color="card.boardColumn.cor"
                    :boardColumnId="card.boardColumn.id"
                    :boardPosition="
                      card.boardColumn.position ? card.boardColumn.position : 0
                    "
                    :percentage="card.boardColumn.percentual"
                    :hoursUntilAlert="card.boardColumn.hoursUntilAlert"
                    :index="index"
                    :hasObservation="false"
                    @Open="showLead(card)"
                  ></task-card>
                </div>
              </b-tab>
              <b-tab v-show="cards.perdidos.length === 0" class="col-md-12" title="PERDIDOS">
                <div
                  class="col-md-4 d-inline-block"
                  v-for="(card, index) in cards.perdidos"
                  :key="card.id"
                >
                  <p>
                    {{ card.boardColumn.board.nome }} --
                    {{ card.boardColumn.nome }}
                  </p>
                  <task-card
                    :task="card"
                    :color="card.boardColumn.cor"
                    :boardColumnId="card.boardColumn.id"
                    :boardPosition="
                      card.boardColumn.position ? card.boardColumn.position : 0
                    "
                    :percentage="card.boardColumn.percentual"
                    :hoursUntilAlert="card.boardColumn.hoursUntilAlert"
                    :index="index"
                    :hasObservation="false"
                    @Open="showLead(card)"
                  ></task-card>
                </div>
              </b-tab>
              <b-tab v-show="cards.finalizados.length === 0" class="col-md-12" title="FINALIZADOS">
                <div
                  class="col-md-4 d-inline-block"
                  v-for="(card, index) in cards.finalizados"
                  :key="card.id"
                >
                  <p>
                    {{ card.boardColumn.board.nome }} --
                    {{ card.boardColumn.nome }}
                  </p>
                  <task-card
                    :task="card"
                    :color="card.boardColumn.cor"
                    :boardColumnId="card.boardColumn.id"
                    :boardPosition="
                      card.boardColumn.position ? card.boardColumn.position : 0
                    "
                    :percentage="card.boardColumn.percentual"
                    :hoursUntilAlert="card.boardColumn.hoursUntilAlert"
                    :index="index"
                    :hasObservation="false"
                    @Open="showLead(card)"
                  ></task-card>
                </div>
              </b-tab>
            </b-tabs>
            <!-- </b-card> -->
          </div>
        </div>
      </div>
      <div class="row mt-5 pt-5">
        <div class="col-12 text-center">
          <img
            src="/static/img/bg/world_re_768g.svg"
            style="width: 40%; opacity: 0.2"
          />
        </div>
      </div>
    </div>
    <ModalCard
      ref="ModalCard"
      v-if="selectedCard"
      @hideModal="hideLead"
      :key="selectedCard"
      isVisita
      :visitaId="visitaId"
      @reloadBoardColumns="() => {}"
      :boardColumns="[]"
      :cardId="selectedCard"
    />
    <NewLeadModal
      ref="NewLeadModal"
      v-if="modalNewLeadOpen"
      @closeModal="closeModalNewLead"
      :pessoa="pessoa"
    />
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'

import DeslocamentoRepository from '@/shared/http/repositories/deslocamento/deslocamento.js'
import CardRepository from '@/shared/http/repositories/crm/card.js'

import TaskCard from '@/views/private/crm/components/TaskCard.vue'
import ModalCard from '@/views/private/crm/components/modalCard/modalCard.vue'
import NewLeadModal from '@/views/private/visitas/deslocamento/modal/newCard/newcard.vue'

export default {
  name: 'FollowUp',
  mixins: [ActionsForm],
  components: {
    TaskCard,
    ModalCard,
    NewLeadModal
  },
  data () {
    return {
      visitaId: null,
      pessoa: null,
      cards: [],
      selectedCard: null,
      modalNewLeadOpen: false
    }
  },
  async mounted () {
    Tools.MinimizedSidebar()
    const resp = await DeslocamentoRepository.GetActive()
    if (
      resp.data === '' ||
        resp.data.visitas === null ||
        resp.data.visitas.length === 0
    ) {
      this.onBack()
      return
    }
    const visita = resp.data.visitas.find(v => v.dataCheckOut === null)
    if (visita === null) {
      this.onBack()
      return
    }
    this.visitaId = visita.id
    this.pessoa = visita.pessoa

    this.loadCards()
  },
  methods: {
    onBack () {
      this.$router.push({ name: 'Visitas' })
    },
    loadCoordinates (data) {
      this.data.latitudeFinal = data.latitude
      this.data.longitudeFinal = data.longitude
    },
    async loadCards () {
      const response = await CardRepository.SearchAllByDocument(
        this.pessoa.document
      )
      let allCards = response.data.content
      let activeCards = allCards.filter(c => c.situacao === 'ATIVO')
      let wonCards = allCards.filter(c => c.situacao === 'GANHO')
      let lostCards = allCards.filter(c => c.situacao === 'PERDIDO')
      let finishedCards = allCards.filter(c => c.situacao === 'FINALIZADO')
      this.cards = {
        ativos: activeCards,
        ganhos: wonCards,
        perdidos: lostCards,
        finalizados: finishedCards
      }
    },

    showLead (card) {
      this.selectedCard = card.id
    },
    hideLead () {
      this.selectedCard = null
    },
    showModalNewLead () {
      this.modalNewLeadOpen = true
    },
    closeModalNewLead () {
      this.modalNewLeadOpen = false
      this.loadCards()
    }
  }
}
</script>
<style lang="scss">
  .card__tab__container {
    .tab-content {
      background-color: #e4e5e6;
      background: #e4e5e6;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/private/visitas/deslocamento/followup.vue